import { uiHelper } from '@/util'
import { GAME_TYPE_GAMES } from '@/store/game.module'

export default {
  methods: {
    getGameBase(gameType) {
        console.log(`getGameBase ${gameType}`)

        if (this.searchCriteria) {
            this.searchCriteria.pageNumber = 1
            this.searchCriteria.provider = this.$route?.params?.provider != 'all' ? this.$route.params.provider : 'all'
        }

        console.log(`searchCriteria ${JSON.stringify(this.searchCriteria)}`)

        this.$store.dispatch(`${GAME_TYPE_GAMES}`, {
            Obj: {
              currency: uiHelper.getCurrency(),
              type: gameType,
              size: '',
              page: '',
              platform: uiHelper.getPlatform(),
              category: '',
              provider: '',
              mode: 'All'
            }
        })
    }
  }
}